
import Vue from 'vue';

import UTILS from '@/store/modules/UtilityModule';
import MISC_DATA from '@/store/modules/MiscDataModule';
import { ApiCustomerReview } from '~/types/misc_data';
import { ErrorResponse } from '~/types/api_helper';
import SectionHeading from '@/components/general/utils/SectionHeading.vue';

export default Vue.extend({
	name: 'UserReviews',

	components: { SectionHeading },

	data() {
		return {
			reviews: [] as ApiCustomerReview[],
			carouselIndex: 0,
			websiteMounted: false
		};
	},

	computed: {
		UTILS: () => UTILS,
		MISC_DATA: () => MISC_DATA,

		isMobile(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		},

		cardGroups(): ApiCustomerReview[][] {
			const result: ApiCustomerReview[][] = [];
			for (let i = 0; i < this.reviews.length; i += 4) {
				result.push(this.reviews.slice(i, i + 4));
			}
			return result;
		},

		cardGroupsMobile(): ApiCustomerReview[][] {
			const result: ApiCustomerReview[][] = [];
			const limitedReviews = this.reviews.slice(0, 6);
			for (let i = 0; i < limitedReviews.length; i += 1) {
				result.push(limitedReviews.slice(i, i + 1));
			}

			return result;
		}
	},
	async created() {
		const response = await this.UTILS.GET_CUST_REVIEWS(this.$getDomain());
		if (!(response instanceof ErrorResponse)) {
			this.reviews = response;
		}
	},

	mounted() {
		this.websiteMounted = true;
	},

	methods: {
		navigateCarousel(direction: string) {
			this.$nextTick(() => {
				const carousel = this.$refs.carousel as Vue & {
					prev: () => void;
					next: () => void;
				};

				if (!carousel) {
					return;
				}

				const totalSlides = this.isMobile ? this.cardGroupsMobile.flat().length : this.cardGroups.length;

				if (direction === 'prev') {
					if (this.carouselIndex > 0) {
						carousel.prev();
					} else {
						this.carouselIndex = totalSlides - 1;
					}
				} else if (direction === 'next') {
					if (this.carouselIndex < totalSlides - 1) {
						carousel.next();
					} else {
						this.carouselIndex = 0;
					}
				}
			});
		},

		showNextRating(index: number): number | null {
			let nextIndex = 0;
			const reviews = this.cardGroupsMobile.flat();

			if (index === 5) {
				nextIndex = 0;
			} else {
				nextIndex = index + 1;
			}

			return reviews[nextIndex]?.rating || 0;
		},

		showNextText(index: number): string | null {
			let nextIndex = 0;
			const reviews = this.cardGroupsMobile.flat();

			if (index === 5) {
				nextIndex = 0;
			} else {
				nextIndex = index + 1;
			}
			return reviews[nextIndex]?.text || '';
		},

		showNextUser(index: number): string | null {
			let nextIndex = 0;
			const reviews = this.cardGroupsMobile.flat();

			if (index === 5) {
				nextIndex = 0;
			} else {
				nextIndex = index + 1;
			}
			return reviews[nextIndex]?.user || '';
		},

		showPrevRating(index: number): number | null {
			let prevIndex = 0;
			const reviews = this.cardGroupsMobile.flat();

			if (index === 0) {
				prevIndex = 5;
			} else {
				prevIndex = index - 1;
			}

			return reviews[prevIndex]?.rating || 0;
		},

		showPrevText(index: number): string | null {
			let prevIndex = 0;
			const reviews = this.cardGroupsMobile.flat();

			if (index === 0) {
				prevIndex = 5;
			} else {
				prevIndex = index - 1;
			}

			return reviews[prevIndex]?.text || '';
		},

		showPrevUser(index: number): string | null {
			let prevIndex = 0;
			const reviews = this.cardGroupsMobile.flat();

			if (index === 0) {
				prevIndex = 5;
			} else {
				prevIndex = index - 1;
			}

			return reviews[prevIndex]?.user || '';
		}
	}
});
